import React, { useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { JoinNetworkForm } from './JoinNetworkForm';
export function MakeDifferenceCTA() {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  const [formOpen, setFormOpen] = useState(false);
  const {
    t,
    language
  } = useLanguage();
  return <section ref={ref} className="bg-white pt-6 pb-10 lg:pt-8 lg:pb-14" data-id="element-2655">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2656">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.2
      }} className="text-center bg-gradient-to-r from-haa-blue via-haa-navy to-haa-blue rounded-3xl px-8 py-6 text-white" data-id="element-2657">
          <h3 className="font-bebas text-3xl sm:text-4xl tracking-wider mb-2" data-id="element-2658">
            {t('leadership.cta.heading')}
          </h3>
          <p className="font-nunito text-white/80 text-base mb-4 max-w-2xl mx-auto leading-relaxed" data-id="element-2659">
            {'Are you a college student, business owner, professional, community leader, faith leader, wanting to learn more, or just looking to connect? Join our network and help build a shared platform elevating Honduran-American voices across both countries.'}
          </p>
          <motion.button onClick={() => setFormOpen(true)} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.97
        }} className="inline-block bg-white text-haa-navy font-nunito font-bold text-sm px-7 py-3 rounded-full hover:bg-haa-offwhite transition-colors shadow-xl" data-id="element-2660">
            {t('leadership.cta.button')}
          </motion.button>
        </motion.div>
      </div>

      <JoinNetworkForm isOpen={formOpen} onClose={() => setFormOpen(false)} data-id="element-2661" />
    </section>;
}